const HOME_PAGE = {
  id: 'HOME',
  displayName: 'Home',
  path: '/',
  sections: [{
    id: 'TOP_HERO',
    displayName: 'Top Hero',
    allowedEntityTypes: ['CALLOUT'],
    allowedCalloutVariants: ['HERO'],
    width: 'TWO_THIRDS',
    layoutGroup: 'top-row'
  }, {
    id: 'TOP_CARD',
    displayName: 'Top Card',
    allowedEntityTypes: ['CALLOUT'],
    allowedCalloutVariants: ['CARD'],
    width: 'ONE_THIRD',
    layoutGroup: 'top-row'
  }, {
    id: 'BANNER_1',
    displayName: 'Banner 1',
    allowedEntityTypes: ['CALLOUT'],
    allowedCalloutVariants: ['BANNER'],
    width: 'FULL'
  }, {
    id: 'BANNER_2',
    displayName: 'Banner 2',
    allowedEntityTypes: ['CALLOUT'],
    allowedCalloutVariants: ['BANNER'],
    width: 'FULL'
  }, {
    id: 'SUGGESTED_COLLECTIONS',
    displayName: 'Suggested Collections',
    allowedEntityTypes: ['COLLECTION'],
    width: 'HALF',
    layoutGroup: 'suggested-collections'
  }, {
    id: 'SUGGESTED_COLLECTIONS_2',
    displayName: 'Suggested Collections 2',
    allowedEntityTypes: ['COLLECTION'],
    width: 'HALF',
    layoutGroup: 'suggested-collections'
  }]
};
const APPS_PAGE = {
  id: 'APPS',
  displayName: 'Apps',
  path: '/apps',
  sections: [{
    id: 'TOP_HERO',
    displayName: 'Top Hero',
    allowedEntityTypes: ['CALLOUT'],
    allowedCalloutVariants: ['HERO'],
    width: 'TWO_THIRDS',
    layoutGroup: 'top-row'
  }, {
    id: 'TOP_CARD',
    displayName: 'Top Card',
    allowedEntityTypes: ['CALLOUT'],
    allowedCalloutVariants: ['CARD'],
    width: 'ONE_THIRD',
    layoutGroup: 'top-row'
  }, {
    id: 'BANNER_1',
    displayName: 'Banner 1',
    allowedEntityTypes: ['CALLOUT'],
    allowedCalloutVariants: ['BANNER'],
    width: 'FULL'
  }, {
    id: 'SUGGESTED_COLLECTIONS',
    displayName: 'Suggested Collections',
    allowedEntityTypes: ['COLLECTION'],
    width: 'HALF',
    layoutGroup: 'suggested-collections'
  }, {
    id: 'SUGGESTED_COLLECTIONS_2',
    displayName: 'Suggested Collections 2',
    allowedEntityTypes: ['COLLECTION'],
    width: 'HALF',
    layoutGroup: 'suggested-collections'
  }]
};
const AGENTS_PAGE = {
  id: 'AGENTS',
  displayName: 'Agents',
  path: '/breeze-agents',
  sections: [{
    id: 'TOP_HERO',
    displayName: 'Top Hero',
    allowedEntityTypes: ['CALLOUT'],
    allowedCalloutVariants: ['HERO'],
    width: 'TWO_THIRDS',
    layoutGroup: 'top-row'
  }, {
    id: 'TOP_CARD',
    displayName: 'Top Card',
    allowedEntityTypes: ['CALLOUT'],
    allowedCalloutVariants: ['CARD'],
    width: 'ONE_THIRD',
    layoutGroup: 'top-row'
  }, {
    id: 'FEATURED_COLLECTION',
    displayName: 'Featured Collection',
    allowedEntityTypes: ['COLLECTION'],
    width: 'HALF',
    layoutGroup: 'featured-collection'
  }, {
    id: 'FEATURED_COLLECTION_2',
    displayName: 'Featured Collection 2',
    allowedEntityTypes: ['COLLECTION'],
    width: 'HALF',
    layoutGroup: 'featured-collection'
  }]
};
const WORKFLOWS_PAGE = {
  id: 'WORKFLOWS',
  displayName: 'Workflows',
  path: '/workflows',
  sections: [{
    id: 'TOP_HERO',
    displayName: 'Top Hero',
    allowedEntityTypes: ['CALLOUT'],
    allowedCalloutVariants: ['HERO'],
    width: 'TWO_THIRDS',
    layoutGroup: 'top-row'
  }, {
    id: 'TOP_CARD',
    displayName: 'Top Card',
    allowedEntityTypes: ['CALLOUT'],
    allowedCalloutVariants: ['CARD'],
    width: 'ONE_THIRD',
    layoutGroup: 'top-row'
  }]
};
const FEATURED_PAGE = {
  id: 'FEATURED',
  displayName: 'Featured',
  path: '/featured',
  sections: [{
    id: 'TOP_HERO',
    displayName: 'Top Hero',
    allowedEntityTypes: ['CALLOUT'],
    allowedCalloutVariants: ['HERO'],
    width: 'TWO_THIRDS',
    layoutGroup: 'top-row'
  }, {
    id: 'TOP_CARD',
    displayName: 'Top Card',
    allowedEntityTypes: ['CALLOUT'],
    allowedCalloutVariants: ['CARD'],
    width: 'ONE_THIRD',
    layoutGroup: 'top-row'
  }, {
    id: 'MID_PAGE_UMBRELLA',
    displayName: 'Mid-page Umbrella Collection',
    allowedEntityTypes: ['COLLECTION'],
    width: 'HALF',
    layoutGroup: 'mid-page-umbrella'
  }, {
    id: 'MID_PAGE_UMBRELLA_2',
    displayName: 'Mid-page Umbrella Collection 2',
    allowedEntityTypes: ['COLLECTION'],
    width: 'HALF',
    layoutGroup: 'mid-page-umbrella'
  }]
};
const FEATURED_COLLECTION_PAGE = {
  id: 'FEATURED_COLLECTION',
  displayName: 'AI Essentials',
  path: '/featured/:collectionSlug',
  sections: [{
    id: 'TOP_HERO',
    displayName: 'Top Hero',
    allowedEntityTypes: ['CALLOUT'],
    allowedCalloutVariants: ['HERO'],
    width: 'TWO_THIRDS',
    layoutGroup: 'top-row'
  }, {
    id: 'TOP_CARD',
    displayName: 'Top Card',
    allowedEntityTypes: ['CALLOUT'],
    allowedCalloutVariants: ['CARD'],
    width: 'ONE_THIRD',
    layoutGroup: 'top-row'
  }, {
    id: 'BANNER_1',
    displayName: 'Banner 1',
    allowedEntityTypes: ['CALLOUT'],
    allowedCalloutVariants: ['BANNER'],
    width: 'FULL'
  }, {
    id: 'SUGGESTED_COLLECTIONS',
    displayName: 'Suggested Collections',
    allowedEntityTypes: ['COLLECTION'],
    width: 'HALF',
    layoutGroup: 'suggested-collections'
  }, {
    id: 'SUGGESTED_COLLECTIONS_2',
    displayName: 'Suggested Collections 2',
    allowedEntityTypes: ['COLLECTION'],
    width: 'HALF',
    layoutGroup: 'suggested-collections'
  }]
};
const SOLUTIONS_PARTNERS_PAGE = {
  id: 'SOLUTIONS_PARTNERS',
  displayName: 'Solutions Partners',
  path: '/solutions',
  sections: [{
    id: 'TOP_HERO',
    displayName: 'Top Hero',
    allowedEntityTypes: ['CALLOUT'],
    allowedCalloutVariants: ['HERO'],
    width: 'TWO_THIRDS',
    layoutGroup: 'top-row'
  }, {
    id: 'TOP_CARD',
    displayName: 'Top Card',
    allowedEntityTypes: ['CALLOUT'],
    allowedCalloutVariants: ['CARD'],
    width: 'ONE_THIRD',
    layoutGroup: 'top-row'
  }, {
    id: 'SUGGESTED_COLLECTIONS',
    displayName: 'Suggested Collections',
    allowedEntityTypes: ['COLLECTION'],
    width: 'HALF',
    layoutGroup: 'suggested-collections'
  }, {
    id: 'SUGGESTED_COLLECTIONS_2',
    displayName: 'Suggested Collections 2',
    allowedEntityTypes: ['COLLECTION'],
    width: 'HALF',
    layoutGroup: 'suggested-collections'
  }]
};
export const PAGE_CATALOG = {
  HOME: HOME_PAGE,
  APPS: APPS_PAGE,
  AGENTS: AGENTS_PAGE,
  WORKFLOWS: WORKFLOWS_PAGE,
  FEATURED: FEATURED_PAGE,
  FEATURED_COLLECTION: FEATURED_COLLECTION_PAGE,
  SOLUTIONS_PARTNERS: SOLUTIONS_PARTNERS_PAGE
};
export const ALL_PAGES = [HOME_PAGE, APPS_PAGE, AGENTS_PAGE, WORKFLOWS_PAGE, SOLUTIONS_PARTNERS_PAGE, FEATURED_COLLECTION_PAGE];